import React from 'react';
import DocumentTemplateConfiguration from '../../DocumentTemplateConfiguration/DocumentTemplateConfiguration';
import { Grid, Header, Segment, Tab } from 'semantic-ui-react';
import Responsive from 'semantic-ui-react/dist/commonjs/addons/Responsive';
import { ToastContainer } from 'react-toastify';


export default class Configurations extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            step: 0
        };
        this.changeStep = this.changeStep.bind(this);
    }

    changeStep(step) {
        this.setState({ step });
    }

    componentDidMount() {
        let element = document.querySelectorAll('#myTab:nth-child(1)');
        element[0].childNodes[1].classList.remove('segment');
        let activeRole = localStorage.getItem('activeRole');
        window.localStorage.clear();
        localStorage.setItem('activeRole', activeRole);
    }


    render() {
        const { step } = this.state;
        const panes = [
            {
                menuItem: 'Pregled',
                render: () => (<Tab.Pane attached={false} responsive={Responsive} >
                    <DocumentTemplateConfiguration
                        studentService
                        changeStep={this.changeStep}
                    />
                </Tab.Pane>),
            },
            {
                menuItem: 'Kreiranje',
                render: () => (<Tab.Pane attached={false} responsive={Responsive}>
                    <DocumentTemplateConfiguration
                        studentService
                        manipulateConfig
                        changeStep={this.changeStep}
                    />
                </Tab.Pane>),
            },

        ];
        return (
            <div>
                <h1> Konfiguracije dokumenata </h1>
                <Grid columns="equal" centered className="stackable">
                    <Grid.Column>
                        <Segment.Group raised>
                            <Segment>
                                <Header as="h3">
                                    Konfiguracija
                                </Header>
                            </Segment>
                            <Segment>
                                <Tab id="myTab" menu={{ secondary: true, pointing: true, color: 'blue' }} panes={panes} />
                            </Segment>
                            <ToastContainer hideProgressBar />
                        </Segment.Group>
                    </Grid.Column>
                </Grid>
                {/*<Segment.Group raised>*/}
                {/*    <Segment>*/}
                {/*        <Tab id="myTab" menu={{ secondary: true, pointing: true, color: 'blue' }} panes={panes} />*/}
                {/*    </Segment>*/}
                {/*</Segment.Group>*/}
                <ToastContainer hideProgressBar />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentService/Configuration/Configurations.js